import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { TicketRow, TicketThread } from "@/pages/client/ClientSupport";

const FILTERS = ["open", "answered", "closed", "all"];

export const SupportTab = () => {
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState("open");
  const [open, setOpen] = useState(null);

  const load = () => api.get("/admin/tickets").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const reply = (id) => async (text) => { await api.post(`/admin/tickets/${id}/messages`, { text }); toast.success("Reply sent — client notified."); await load(); };
  const setStatus = (id, status) => async () => { try { await api.patch(`/admin/tickets/${id}/status`, { status }); await load(); } catch (e) { toast.error(formatApiError(e)); } };

  const shown = rows.filter((t) => filter === "all" || t.status === filter);

  return (
    <div data-testid="admin-support-tab">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h2 className="font-display text-2xl font-semibold tracking-tight">Support Tickets</h2>
          <p className="mt-1 text-sm text-slate-500">Client questions from the portal. Replies are posted to the client's ticket and sent as a notification.</p>
        </div>
        <div className="flex gap-px border border-slate-200 bg-slate-200">
          {FILTERS.map((f) => (
            <button key={f} data-testid={`admin-support-filter-${f}`} onClick={() => setFilter(f)} className={`px-4 py-2 font-mono2 text-[10px] uppercase tracking-[0.2em] ${filter === f ? "bg-[#6D28D9] text-white" : "bg-[#F6F4FD] text-slate-500 hover:text-[#6D28D9]"}`}>
              {f} ({f === "all" ? rows.length : rows.filter((t) => t.status === f).length})
            </button>
          ))}
        </div>
      </div>
      <div data-testid="admin-tickets-list" className="mt-8 space-y-3">
        {shown.map((t) => (
          <TicketRow key={t.id} t={{ ...t, subject: `${t.subject} — ${t.name}` }} open={open === t.id} onToggle={() => setOpen(open === t.id ? null : t.id)}>
            <div className="border-t border-slate-200 bg-[#F6F4FD] px-5 py-2 font-mono2 text-[10px] uppercase tracking-[0.15em] text-slate-500">{t.email}{t.client_id ? ` · ${t.client_id}` : ""}{t.phone ? ` · ${t.phone}` : ""}</div>
            <TicketThread ticket={t} onReply={reply(t.id)} onClose={setStatus(t.id, "closed")} replyLabel="Send reply" testPrefix="admin-ticket" />
            {t.status === "closed" && <div className="border-t border-slate-200 px-5 py-3"><button data-testid={`admin-ticket-reopen-${t.id}`} onClick={setStatus(t.id, "open")} className="font-mono2 text-[10px] uppercase tracking-[0.15em] text-[#6D28D9] hover:underline">Reopen ticket</button></div>}
          </TicketRow>
        ))}
        {shown.length === 0 && <p data-testid="admin-tickets-empty" className="border border-dashed border-slate-300 py-14 text-center font-mono2 text-xs uppercase tracking-[0.25em] text-slate-500">No {filter === "all" ? "" : filter} tickets</p>}
      </div>
    </div>
  );
};
